export const getIconBySupportAgent = (authorEmail: string) => {
  if (authorEmail.includes('@nemuru.com')) return 'support_agent';
  if (
    authorEmail.includes('@caixabankpc.com') ||
    authorEmail.includes('@bancsabadell.com') ||
    authorEmail.includes('@bbva.com') ||
    authorEmail.includes('@sofinco.es') ||
    authorEmail.includes('@cofidis.es') ||
    authorEmail.includes('@sequra.es') ||
    authorEmail.includes('@aplazame.com') ||
    authorEmail.includes('@floa.com')
  )
    return 'account_balance';
  return 'person';
};
